
export const user_config = {  
  methods: {    
    /**
     * user 테이블의 config 컬럼에 지정한 item 정보를 가져옵니다.
     * @param {user 테이블 정보} userTableData 
     * @param {config 컬럼에서 가져올 item 이름} configItemName 
     */
    getSelectedColumnData(userTableData, configItemName) {
      let selected_columns = [];      

      // config 컬럼에 정보가 없는 경우
      if (!userTableData.config) {
        userTableData.config = {};
        userTableData.config[configItemName] = {};
        this.column_items.forEach( item => {
          userTableData.config[configItemName][item.key] = 'Y';
          selected_columns.push(item.key);
        });
      // config 컬럼에 정보는 있지만, 지정한 config 컬럼 정보가 없는 경우
      } else if (!userTableData.config[configItemName]) {
        userTableData.config[configItemName] = {};
        this.column_items.forEach( item => {
          userTableData.config[configItemName][item.key] = 'Y';
          selected_columns.push(item.key);
        });
      // config 컬럼에 지정한 config 컬럼 정보가 있는 경우
      } else {
        this.column_items.forEach( item => {
          if (userTableData.config[configItemName][item.key] === 'Y') {
            selected_columns.push(item.key);
          }
        });
      }      
      return selected_columns;
    },

    /**
     * user 테이블의 config 컬럼에 지정한 item 정보를 적용합니다.
     * @param {user 테이블 정보} userTableData 
     * @param {테이블 컬럼 정보} columnItems
     * @param {config 컬럼에 적용할 컬럼 정보} columnData 
     * @param {config 컬럼에 적용할 item 이름} configItemName 
     */
    setSelectedColumnData(userTableData, columnItems, columnData, configItemName) {
      // 지정한 config 컬럼 정보를 config 컬럼에 JSON 형태로 저장
      if (columnItems.length === columnData.length) {
        columnData.forEach( item => {
          userTableData.config[configItemName][item] = 'Y';
        });      
      } else {
        columnItems.forEach( item => {        
          let checkedItem = columnData.find(findItem => findItem === item.key);        
          if (checkedItem === undefined) userTableData.config[configItemName][item.key] = 'N';
          else userTableData.config[configItemName][checkedItem] = 'Y';
        });
      }          

      this.api.updateUser(userTableData).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
      });
    },
  },
}